import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiPartnerCodeLookup extends Layout {
}
